import { render, staticRenderFns } from "./RoomControl.vue?vue&type=template&id=6a2da577&scoped=true&"
import script from "./RoomControl.vue?vue&type=script&lang=js&"
export * from "./RoomControl.vue?vue&type=script&lang=js&"
import style0 from "./RoomControl.vue?vue&type=style&index=0&id=6a2da577&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a2da577",
  null
  
)

export default component.exports